import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

export interface SystemField {
  id: string;
  countryId: number;
  country?: unknown;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription?: string;
  dataType: number;
  formula: Formula;
  note: string;
}

interface Formula {
  pattern: string;
}

export interface SystemFieldListRequest {
  page?: number;
  limit?: number;
  name?: string | null;
  code?: string | null;
  status?: number | null;
}

export interface SystemFieldCreateRequest {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  effectiveFrom: string;
  unit: number;
  amount: number;
  byType?: number;
  status: number;
  minWorkDayRate: number;
  pit: boolean;
  insurance: boolean;
}

export interface SystemFieldUpdateRequest extends SystemFieldCreateRequest {
  id: string;
}

export interface SystemFieldListResponse extends RestAPIMetaResponse {
  items: Array<SystemField>;
}

export enum SystemFieldUnit {
  Day = 1,
  Month = 3,
}

export enum SystemFieldDataType {
  TEXT = 1,
  NUMBER = 3,
  PERCENT = 5,
  DATE = 7,
  BOOLEAN = 9,
}

export enum SystemFieldDataTypePA {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  PERCENT = "PERCENT",
  DATE = "DATE",
  BOOLEAN = "BOOLEAN",
}

export enum PASystemFieldDataType {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  PERCENT = "PERCENT",
  DATE = "DATE",
  BOOLEAN = "BOOLEAN",
}

export enum SystemFieldGroupData {
  ALLOWANCE = 1,
  EMPLOYEE_DATA = 3,
  PAYROLL_SETTING = 5,
  SALARY_DATA = 7,
  INSURANCE_DATA = 9,
  PIT_DATA = 11,
  DEDUCTION = 13,
  TIME_ATTENDANCE = 15,
}

export const SystemFieldGroupDataName: {
  [key in SystemFieldGroupData]: string;
} = {
  [SystemFieldGroupData.ALLOWANCE]: "Allowance",
  [SystemFieldGroupData.EMPLOYEE_DATA]: "Employee Data",
  [SystemFieldGroupData.PAYROLL_SETTING]: "Payroll Settings",
  [SystemFieldGroupData.SALARY_DATA]: "Salary Data",
  [SystemFieldGroupData.INSURANCE_DATA]: "Insurance Data",
  [SystemFieldGroupData.PIT_DATA]: "PIT Data",
  [SystemFieldGroupData.DEDUCTION]: "Deduction",
  [SystemFieldGroupData.TIME_ATTENDANCE]: "Time Attendance",
};

export const SystemFieldDataOptions = [
  {
    label: i18n.t("text"),
    value: SystemFieldDataType.TEXT,
  },
  {
    label: i18n.t("number"),
    value: SystemFieldDataType.NUMBER,
  },
  {
    label: i18n.t("date"),
    value: SystemFieldDataType.DATE,
  },
  {
    label: i18n.t("percent"),
    value: SystemFieldDataType.PERCENT,
  },
  {
    label: i18n.t("date"),
    value: SystemFieldDataType.DATE,
  },
  {
    label: i18n.t("Boolean"),
    value: SystemFieldDataType.BOOLEAN,
  },
];

export const PASystemFieldDataOptions = [
  {
    label: i18n.t("text"),
    value: PASystemFieldDataType.TEXT,
  },
  {
    label: i18n.t("number"),
    value: PASystemFieldDataType.NUMBER,
  },
  {
    label: i18n.t("date"),
    value: PASystemFieldDataType.DATE,
  },
  {
    label: i18n.t("percent"),
    value: PASystemFieldDataType.PERCENT,
  },
  {
    label: i18n.t("Boolean"),
    value: PASystemFieldDataType.BOOLEAN,
  },
];

export const PASystemFieldDataOptionsMap = getMapObjectFromArray(
  PASystemFieldDataOptions
);

export const SystemFieldDataOptionsMap = getMapObjectFromArray(
  SystemFieldDataOptions
);
